import { useIsDesktopDevice } from "../../tools/hooks/useIsDesktopDevice.ts";
import type UserResetPasswordProperties from "./UserResetPassword.properties.ts";
import UserResetPasswordDesktopView from "./desktop/UserResetPassword.desktop.view.tsx";

export default function UserResetPasswordView(
  props: UserResetPasswordProperties,
) {
  const isDesktop = useIsDesktopDevice();

  return <>{isDesktop && <UserResetPasswordDesktopView {...props} />}</>;
}
